import { connect, useSelector } from 'react-redux'
import { useState, useMemo } from 'react'
import moment from 'moment';

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import Form from '../../../containers/Form/Form'
import Input from '../../../containers/Form/Input'
import Button from '../../../containers/Form/Button'
import ConfirmDialog from '../../../containers/ConfirmDialog';

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_mcl_tweet_save, tool_mcl_tweet_delete, tool_mcl_tweet_list } from "../../../app/apiEndpoints"
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'

const MCLTwitterTool = (props) => {
    const toolID = 6
    const [tool, setTool] = useState({})
    const [inputValue, setInputValue] = useState({ tweet: "", date: new Date()});
    const [errors, setErrors] = useState({ tweet: "", date: "" });
    const { tweet, date } = inputValue;
    const [formMessage, setFormMessage] = useState('')
    const [hasErrors, setHasErrors] = useState(false)
    const [status, setStatus] = useState(0)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [tweets, setTweets] = useState([])
    const [curTweet, setCurTweet] = useState(-1)

    const tableID = "result"
    const tableFields = ["Tweet", "Scheduled Date"]

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useMemo(() => {
        const getList = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_mcl_tweet_list, { 'requester': userID, 'company': companyID })
                setTweets(data.tweets)
            }
        }
        getList()
    }, [userID, companyID])

    const tableData = () => {
        if(tweets.length === 0) {
            return [];
        } 

        let rows = [];
        tweets.forEach(row => {
            rows.push({'id': row.id, 'deleteFnc': confirmDeleteTweet, 'values': [
                row.tweet,
                row.date
            ]});
        });
        return rows
    }

    const saveTweet = async (e) => {
        e.preventDefault()
        let formErrors = []
        setHasErrors(false)
        for (const field of Object.entries(errors)) {
            const error = field[1]
            if(error.length > 0) formErrors.push(error)
        }
        if(formErrors.length > 0) { 
            setHasErrors(true)
            setFormMessage(formErrors.join('<br/>'))
            return
        }
        setFormMessage('')

        setStatus(1)

        const data = await toolsAPICall(tool_mcl_tweet_save, {
            'requester': userID, 
            'company': companyID, 
            'tweet': tweet,
            'date': moment(date).format('YYYY-MM-DD HH:mm:ss') 
        })

        //if successful, delete from project object
        if(!data.success && data.error) {
            setFormMessage(data.error)
            setHasErrors(true)
            setStatus(0)
            return
        } 

        if(data.tweets) {
            setFormMessage("Tweet Saved")
            setTweets(data.tweets)
            setStatus(2)
        }
    }

    const confirmDeleteTweet = (e) => {
        e.preventDefault()
        console.log(e)
        let rowID = e.target.id
        rowID = rowID.replace(`delete_`, "")
        if(parseInt(rowID) > 0) {
            setCurTweet(parseInt(rowID))
            setShowConfirmDelete(true)
        }
    }

    const deleteTweet = async (e) => {
        setShowConfirmDelete(false)
        if(curTweet <= 0) return;
        const data = await toolsAPICall(tool_mcl_tweet_delete, {
            'requester': userID, 
            'company': companyID, 
            'tweetID': curTweet
        })

        //if successful, delete from project object
        if(!data.success && data.error) {
            setFormMessage(data.error)
            setHasErrors(true)
            return
        } 

        if(data.tweets) {
            setTweets(data.tweets)
        }
    }

    const newTweet = () => {
        setInputValue((prev) => ({
          tweet: "", date: ""
        }));
        setFormMessage("")
        setStatus(0)
    }

    const handleChange = (e) => {
        console.log(e)
        let { name, value } = e.target;

        setInputValue((prev) => ({
          ...prev,
          [name]: value,
        }));
    };
    
    const handleError = (field, error) => {
        setErrors((prev) => ({
            ...prev,
            [field]: error,
        }));
    };

    if(!tool) return <></>

    return (
        <>
                <Form title={tool.tool_name} description={tool.description} onSubmit={saveTweet}>  
                <Card.Body>
                    <Input
                        type="text"
                        value={tweet}
                        placeholder="Tweet"
                        label="Tweet"
                        name="tweet"
                        onChange={handleChange}
                        onError={handleError}
                        validate="required"
                        colSize="9"
                        readOnly={status !== 0}
                    />
                    <Input
                        type="datetime"
                        value={date}
                        placeholder="Post Date"
                        label="Post Date"
                        name="date"
                        onChange={handleChange}
                        onError={handleError}
                        validate="date|required"
                        colSize="6"
                        readOnly={status !== 0}
                    />
                    <Row>
                        <Col className="text-center">
                            <Card.Text className={hasErrors ? "text-danger" : "text-success"}>{formMessage}</Card.Text>
                            {status === 0 ? <Button title="Save Tweet" className="primary" /> : null}
                            {status === 2 ? <Button title="New Tweet" className="primary" onClick={newTweet} /> : null}
                        </Col>
                    </Row>
                </Card.Body>
                </Form>
                <ConfirmDialog
                    show={showConfirmDelete}
                    title="Delete Tweet" message="Are you sure you wish to delete this Tweet?"
                    onClose={() => { setShowConfirmDelete(false) }}
                    onConfirm={deleteTweet}
                />
                <Card>
                    <CardHeader title="Upcoming Tweets" description="Tweets that will be posted to @chastitylife101 soon" />
                    <DataTable hover={false} tableID={tableID} fieldNames={tableFields} dataRows={tableData()} tableSettings={tableTypes.None} />
                </Card>
                
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(MCLTwitterTool), "MCL Tweet Scheduler"));